
import { GARDEN_SCIENTIST_QUESTS } from './garden-scientist';
import { FORT_MASTER_QUESTS } from './fort-master';
import { BUG_SCIENTIST_QUESTS } from './bug-scientist';
import { STANDARD_EXPLORER_QUESTS } from './standard';
import { SKATER_APPRENTICE_QUESTS } from './skater-apprentice';

export const EXPLORER_QUESTS = [
    ...GARDEN_SCIENTIST_QUESTS,
    ...FORT_MASTER_QUESTS,
    ...BUG_SCIENTIST_QUESTS,
    ...STANDARD_EXPLORER_QUESTS,
    ...SKATER_APPRENTICE_QUESTS,
];